import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

import { User } from '../../models/main';

@Component({
  selector: 'app-user-multiple-select',
  templateUrl: './user-multiple-select.component.html',
  styleUrls: ['./user-multiple-select.component.scss'],
})
export class UserMultipleSelectComponent {

  @Input() control!: AbstractControl | null;
  @Input() users: User[] = [];
  @Input() label: string = '';

  constructor() { }

  get aFormControl(): FormControl {
    return this.control as FormControl;
  }
}
